import { create } from "zustand";

export type LoginFormType = "regular" | "checkout";

type LoginRegistrationModalState = {
  isOpen: boolean;
  redirectUrl: string;
  formType: LoginFormType;
  open: (options: { redirectUrl: string; formType?: LoginFormType }) => void;
  close: () => void;
};

export const useLoginRegistrationModal = create<LoginRegistrationModalState>()(
  (set) => ({
    isOpen: false,
    redirectUrl: "/",
    formType: "regular",
    open: ({ redirectUrl, formType = "regular" }) =>
      set({ isOpen: true, redirectUrl, formType }),
    close: () => set({ isOpen: false }),
  })
);

export const openLoginRegistrationModal = (options: {
  redirectUrl: string;
  formType?: LoginFormType;
}) => useLoginRegistrationModal.getState().open(options);
